/* global t */
// Help articles for payroll and the mileage log. Merged into helpArticles() in help-articles.jsx.
// Screenshots use the PlummeDEMO business so no customer data is exposed.
window.PlummeHelpArticlePacks = (window.PlummeHelpArticlePacks || []).concat([() => ({
  payrollRun: { id: 'payrollRun', title: t('ha.payrollRun.title'), category: t('ha.cat.payroll'), read: t('ha.read3'), route: 'lonn',
    keywords: t('ha.payrollRun.keywords'),
    lead: t('ha.payrollRun.lead'),
    blocks: [
    { t: 'heading', text: t('ha.h6.before') },
    { t: 'para', text: t('ha.payrollRun.beforeText') },
    { t: 'step', n: 1, title: t('ha.payrollRun.employee'), text: t('ha.payrollRun.employeeText') },
    { t: 'step', n: 2, title: t('ha.payrollRun.fixed'), text: t('ha.payrollRun.fixedText') },
    { t: 'step', n: 3, title: t('ha.payrollRun.create'), text: t('ha.payrollRun.createText') },
    { t: 'step', n: 4, title: t('ha.payrollRun.lines'), text: t('ha.payrollRun.linesText') },
    { t: 'step', n: 5, title: t('ha.payrollRun.ameld'), text: t('ha.payrollRun.ameldText') },
    { t: 'tip', kind: 'warn', title: t('ha.payrollRun.ameldWarn'), text: t('ha.payrollRun.ameldWarnText') },
    { t: 'step', n: 6, title: t('ha.payrollRun.payslips'), text: t('ha.payrollRun.payslipsText') },
    { t: 'step', n: 7, title: t('ha.payrollRun.pay'), text: t('ha.payrollRun.payText') },
    { t: 'tip', kind: 'info', title: t('ha.payrollRun.taxCard'), text: t('ha.payrollRun.taxCardText') }]
  },
  holidayPay: { id: 'holidayPay', title: t('ha.holidayPay.title'), category: t('ha.cat.payroll'), read: t('ha.read2'), route: 'lonn',
    keywords: t('ha.holidayPay.keywords'),
    lead: t('ha.holidayPay.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.holidayPay.open'), text: t('ha.holidayPay.openText') },
    { t: 'step', n: 2, title: t('ha.holidayPay.choose'), text: t('ha.holidayPay.chooseText') },
    { t: 'tip', kind: 'warn', title: t('ha.holidayPay.previous'), text: t('ha.holidayPay.previousText') },
    { t: 'step', n: 3, title: t('ha.holidayPay.finish'), text: t('ha.holidayPay.finishText') },
    { t: 'tip', kind: 'tip', title: t('ha.holidayPay.list'), text: t('ha.holidayPay.listText') }]
  },
  mileage: { id: 'mileage', title: t('ha.mileage.title'), category: t('ha.cat.payroll'), read: t('ha.read2'), route: 'kjorebok',
    keywords: t('ha.mileage.keywords'),
    lead: t('ha.mileage.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.mileage.trip'), text: t('ha.mileage.tripText') },
    { t: 'step', n: 2, title: t('ha.mileage.km'), text: t('ha.mileage.kmText') },
    { t: 'step', n: 3, title: t('ha.mileage.save'), text: t('ha.mileage.saveText') },
    { t: 'tip', kind: 'info', title: t('ha.mileage.privateCar'), text: t('ha.mileage.privateCarText') },
    { t: 'para', text: t('ha.mileage.sourceText') },
    { t: 'tip', kind: 'info', title: t('ha.mileage.posting'), text: t('ha.mileage.postingText') },
    { t: 'tip', kind: 'tip', title: t('ha.mileage.employees'), text: t('ha.mileage.employeesText') }]
  }
})]);
